<template>
    <div>
        <!-- 轮播图 -->
        <div class="bg">
            <div class="sub-title">News</div>
            <!-- <div class="title">新闻中心</div> -->
        </div>
        <div class="p-3">
            <el-timeline>
                <el-timeline-item placement="top" v-for="(item, index) in newsList" :key="index">
                    <div class="flex-row justify-around">
                        <div>
                            <div class="sub-time">{{ item.occuDate }}</div>
                        </div>
                        <div style="width: 200px;">
                            <div @click="goPage(item.ettribute1)">{{ item.title }}</div>
                            <!-- <p>{{item.title}}</p> -->
                        </div>
                    </div>
                </el-timeline-item>
            </el-timeline>
        </div>
    </div>
</template>
  
<script type="text/babel">
export default {
    name: "HomePage",
    data() {
        return {
            goPage(url){
                            if(url!=''&&url!=null){
                                window.location.href = url
                            }
                            
                        },
                        newsList:[

                ]

            //             newsList:[
            //     {
            //         id: '001',
            //         title: "China's industrial vehicle electric control core technology to achieve independent controllability - industry well-known media in the fork network interview with Fanji technology",
            //         // introduce: '凡己科技（苏州）有限公司的“FJ-D1高效交流控制器及M1智能仪表组件”荣获零部件类金奖。', 
            //         date: '07-08',
            //         year: '2022.07',
            //         redurl:'https://mp.weixin.qq.com/s/gcL2HyQGARk-lNaa4SnRvw'
            //     },{
            //         id: '002',
            //         title: 'The first domestic off-road electric vehicle controller standard drafted by Fanji Technology was approved and released by China Construction Machinery Industry Association',
            //         // introduce: '据悉，在搭载了凡己电控的众多电动叉车中，不乏有远销海外并在极端恶劣工况下工作，客户反响极好，通过其他国家地区客户的认可与验证，这也再次证明了中国制造的实力。 ',
            //         date: '06-10',
            //         year: '2022.06',
            //         redurl:'https://mp.weixin.qq.com/s/6Lxc41T5nOOWR32jBJQOFA'
            //     },{
            //         id: '003',
            //         title: 'Alliance together, win-win cooperation - Fanji Technology supplier Strategy Seminar and 10th anniversary dinner successfully held',
            //         // introduce: '苏商联合产业投资基金与凡己科技就深入开展电驱动领域合作达成战略协议，双方对绿色驱动的前景共同看好，约定在凡己科技进一步发展的产业布局、资源投入、规范化治理等诸多事项上共同努力。',
            //         date: '01-22',
            //         year: '2022.01',
            //         redurl:'https://mp.weixin.qq.com/s/PKilJfR65i8pzp78AOyUQQ'
            //     },{
            //         id: '004',
            //         title: "Nine years of hard work results today to welcome guests - China's industrial vehicle industry leaders to Fanji Technology (Suzhou) Co., LTD",
            //         // introduce: '经过杭叉集团和用户的双重验证，凡己电控的可靠性得到了极大的肯定。国产电控和进口电控的差剧正以肉眼可见的速度缩小，甚至两者在各项性能上的优劣已经趋于模糊。',
            //         date: '09-24',
            //         year: '2020.09',
            //         redurl:'https://mp.weixin.qq.com/s/63HyfjeBUFTksg7XdAkz2Q'
            //     },{
            //         id: '005',
            //         title: 'Professional casting brand high quality to help the development of sightseeing car industry - Fanji technology exchange and share at the annual meeting of sightseeing car industry',
            //         // introduce: '凡己科技通过三年时间的发展与技术进步，成为了国内有成熟技术的国产电控生产企业，已与国内多家知名叉车厂商建立了合作关系，并不断在扩大产业范围。',
            //         date: '10-13',
            //         year: '2019.10',
            //         redurl:'https://mp.weixin.qq.com/s/oAQJj4PFZi8WlN5yJhe_VA'
            //     },{
            //         id: '006',
            //         title: 'Fanji Technology AC controller and intelligent instrument won the gold Award of "China Industrial Vehicle Innovation Award"',
            //         // introduce: '经过六年创新创业，公司进入了新的发展阶段，凡己电控在工业车辆行业全面推广，公司新产品在新的行业领域应用取得进展。',
            //         date: '09-09',
            //         year: '2019.09',
            //         redurl:'https://mp.weixin.qq.com/s/jFhF8M6ykIayUmawWIcdrA'
            //     },{
            //         id: '007',
            //         title: 'What, the sun is so hot, the forklift gets sunstroke?',
            //         // introduce: '凡己科技作为唯一电控厂家受邀列席并与大家分享了凡己科技电控产品的特点和优势。',
            //         date: '07-31',
            //         year: '2019.07',
            //         redurl:'https://mp.weixin.qq.com/s/FGWDxaFbykS7WXZVfAM3_w'
            //     },{
            //         id: '008',
            //         title: 'Why is our company determined not to do semi-AC electronic control',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '05-15',
            //         year: '2019.05',
            //         redurl:'https://mp.weixin.qq.com/s/fJTQU2ZWPzoJ4zxdWek_xA'
            //     },{
            //         id: '009',
            //         title: 'Customer satisfaction - The treasure of the series of reports on the return visit of Fanji technology customers',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '03-18',
            //         year: '2019.03',
            //         redurl:'https://mp.weixin.qq.com/s/xGGLySw1R7vEL0bfcxtnnw'
            //     },{
            //         id: '010',
            //         title: 'The electronic control service provider around you - Fanji technology "service year" fully opened',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '02-15',
            //         year: '2019.02',
            //         redurl:'https://mp.weixin.qq.com/s/qU1P5v9yYtV8XZNyj75Qdg'
            //     },{
            //         id: '011',
            //         title: 'Fan Ji electronic control is not afraid of cold storage test - Fan Ji technology customer return visit series report of the dragon work',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '01-27',
            //         year: '2019.01',
            //         redurl:'https://mp.weixin.qq.com/s/p9SMoCkdxViuRySkuBLt-A'
            //     },{
            //         id: '012',
            //         title: 'Independent core technology to help the national industry - the joint article of the series of reports on the return visit of Fanji technology customers',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '01-12',
            //         year: '2019.01',
            //         redurl:'https://mp.weixin.qq.com/s/yV4sEfCkX4l1L_djAiPBWA'
            //     },{
            //         id: '013',
            //         title: 'Another new chapter - Fanji technology officially entered the sightseeing car industry',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '12-13',
            //         year: '2018.12',
            //         redurl:'https://mp.weixin.qq.com/s/YZodoumO1FwBwStAD_WYrA'
            //     },{
            //         id: '014',
            //         title: 'Market development and service first - Fanji technology to carry out Anhui joint Jiangsu, Guangdong, Shandong regional product training activities',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '12-06',
            //         year: '2018.12',
            //         redurl:'https://mp.weixin.qq.com/s/eZgCuKfRUBIZ6ZzOqfBY4g'
            //     },{
            //         id: '015',
            //         title: 'Fanji technology: adhere to the original heart, rapid development',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '12-20',
            //         year: '2018.12',
            //         redurl:'https://mp.weixin.qq.com/s/n6RFVeRVpTPAIzHT_-ZGKQ'
            //     },{
            //         id: '016',
            //         title: 'Fanji technology intelligent large instrument has become Anhui Heli forklift new standard',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '10-15',
            //         year: '2018.10',
            //         redurl:'https://mp.weixin.qq.com/s/m2zGBVKveiZ4DPXAPx3Zcg'
            //     },{
            //         id: '017',
            //         title: 'Where the "core" products, further capture customers',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '07-31',
            //         year: '2018.07',
            //         redurl:''
            //     },{
            //         id: '018',
            //         title: 'The heat is coming, forklifts should also prevent "heat stroke"',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '06-21',
            //         year: '2018.06',
            //         redurl:'https://mp.weixin.qq.com/s/effQkCly0n5l4vYNcROzGA'
            //     },{
            //         id: '019',
            //         title: 'Talk about how lithium can be missing it...',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '05-30',
            //         year: '2018.05',
            //         redurl:'https://mp.weixin.qq.com/s/wMadpYAAFUSIuS51Yzlq1g'
            //     },{
            //         id: '020',
            //         title: 'The development of new energy for intelligent material handling in China - it is about you, me and him',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '05-13',
            //         year: '2018.05',
            //         redurl:'https://mp.weixin.qq.com/s/hpTo-9VxXDmGeddlV0QoVw'
            //     },{
            //         id: '021',
            //         title: 'Warmly celebrate Fanji Technology (Suzhou) Co., Ltd. elected as the director unit of China Construction Machinery Industry Association Industrial Vehicle Branch',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '02-22',
            //         year: '2018.02',
            //         redurl:''
            //     },{
            //         id: '022',
            //         title: 'All electric control is so resistant, you know? -- Feedback from Fanji electric control users after 5688 hours of use',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '01-04',
            //         year: '2018.01',
            //         redurl:''
            //     },{
            //         id: '023',
            //         title: 'Rigorous cast classic quality years precipitation - from the first user of Fanji electric control 4 and a half years of feedback',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '11-28',
            //         year: '2017.11',
            //         redurl:''
            //     },{
            //         id: '024',
            //         title: 'Fanji Technology signed a strategic cooperation agreement with large investment institutions',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '11-09',
            //         year: '2017.11',
            //         redurl:''
            //     },{
            //         id: '025',
            //         title: 'Dare to bear where have won trust from the quality of solemn promise',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '11-09',
            //         year: '2017.11',
            //         redurl:''
            //     },{
            //         id: '026',
            //         title: '[Logistics equipment] Rigorous achievement of consistent quality China Core creates a new era of forklifts -- Fanji Technology (Suzhou) special topic',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '09-27',
            //         year: '2017.09',
            //         redurl:''
            //     },{
            //         id: '027',
            //         title: 'Xi Jinping: Strengthening the interface between Made in China and Swiss Industry 4.0',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '09-15',
            //         year: '2017.09',
            //         redurl:''
            //     },{
            //         id: '028',
            //         title: 'Innovation to enhance industrial value - CeMAT ASIA2016 exhibition launched the second generation of new products',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '09-01',
            //         year: '2017.09',
            //         redurl:''
            //     },{
            //         id: '029',
            //         title: 'How is the first forklift delivered to the user after Hangzhou Fork is equipped with Fanji electric control?',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '06-09',
            //         year: '2017.06',
            //         redurl:''
            //     },{
            //         id: '030',
            //         title: 'FJ opens new chapter in forklift service industry with new 3-in-1 meter',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '06-09',
            //         year: '2017.06',
            //         redurl:''
            //     },{
            //         id: '031',
            //         title: 'TEU New Product Promotion Conference: Electronic control, choose all the technology!',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '05-25',
            //         year: '2017.05',
            //         redurl:''
            //     },{
            //         id: '032',
            //         title: 'Fanji electric control equipped with a full range of Hangzhou fork products, vehicle remote monitoring data transmission system has also been online',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '04-20',
            //         year: '2017.04',
            //         redurl:''
            //     },{
            //         id: '033',
            //         title: 'Fanji technology core for Zoomlion services',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '04-10',
            //         year: '2017.04',
            //         redurl:''
            //     },{
            //         id: '034',
            //         title: 'Fanji Technology & Ji Xinxiang product exchange training successfully ended',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '03-10',
            //         year: '2017.03',
            //         redurl:''
            //     },{
            //         id: '035',
            //         title: 'Where the science and technology: stride forward do not forget the original heart',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '02-18',
            //         year: '2017.02',
            //         redurl:''
            //     },{
            //         id: '036',
            //         title: 'Fanji technology: dedicated service, we have been doing so!',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '01-19',
            //         year: '2017.01',
            //         redurl:''
            //     },{
            //         id: '037',
            //         title: '2015 Asian Logistics Exhibition (CeMAT) Beijing Fanji Technology control to demonstrate innovative research and development strength',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '01-13',
            //         year: '2017.01',
            //         redurl:''
            //     },{
            //         id: '038',
            //         title: "'Fanji Control is the first to master the core technology of electronic control' was selected as the top ten news of China's industrial vehicle industry in 2014",
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '12-24',
            //         year: '2016.12',
            //         redurl:''
            //     },{
            //         id: '039',
            //         title: 'Beijing Fanji won two product innovation awards of "the first China Industrial Vehicle Innovation Award"',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '11-24',
            //         year: '2016.11',
            //         redurl:''
            //     },{
            //         id: '040',
            //         title: '"China Core" Fanji technology headquarters moved to Suzhou',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '11-15',
            //         year: '2015.11',
            //         redurl:''
            //     },{
            //         id: '041',
            //         title: 'Do you think Fanji technology is just a product?',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '11-15',
            //         year: '2015.11',
            //         redurl:''
            //     },{
            //         id: '042',
            //         title: "FJ's new 3-in-1 instrument drives the new journey of forklift service industry",
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '09-24',
            //         year: '2015.09',
            //         redurl:''
            //     },{
            //         id: '043',
            //         title: 'The controller helps the new development of domestic electric forklift trucks',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '01-15',
            //         year: '2015.01',
            //         redurl:''
            //     },{
            //         id: '044',
            //         title: 'Fanji Keng made a stunning appearance at CeMAT Asia 2014',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '11-09',
            //         year: '2014.11',
            //         redurl:''
            //     },{
            //         id: '045',
            //         title: 'The core technology of perspective FJ electronic control',
            //         // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
            //         date: '10-25',
            //         year: '2014.10',
            //         redurl:''
            //     }
            
            // ]
        };
    },
    methods: {

    },
    mounted() {
        /* banner-swiper */
        debugger
            let that=this;
            this.http.post("/api/FJ_News/GetAllNews?language=1",JSON.stringify({})).then((result)=>{
                debugger
            let objResult= eval(result);
            let iCode= objResult.code;
            if(iCode==0){
                debugger
                that.newsList=objResult.data;
                }
            });

    }
};
</script>
  
<style scoped lang="scss">


.bg {
    background: url('../../assets/img/newsbanner.jpg') no-repeat;
    background-size: 100%;
    height: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.sub-title {
    display: inline-block;
    background-color: #0AA00A;
    color: #fff;
    border-radius: 5px;
    border-top-right-radius: 0;
    font-size: 12px;
    padding: 2px 5px;
}
.title {
    font-size: 20px;
    font-weight: 700;
    margin-top: 5px;
}

.p-3 {
    padding: 15px;
}

.sub-time {
    display: flex;
    background-color: #0AA00A;
    color: #fff;
    padding: 4px;
    border-radius: 5px;
}
.title {
    font-size: 20px;
    font-weight: 700;
    margin-top: 5px;
}
</style>
  


// WEBPACK FOOTER //
// src/views/news/m_index.vue